const en = {
  expenseSaveFailed: 'Could not save the expense. Your details are still here; try again.',
  expenseDeleteFailed: 'Could not remove this expense. It is still saved; try again.',
  settlementFailed: 'Could not record this payment. The balance has not changed; try again.',
  ratesFailed: 'Could not save the rates. Your changes are still here; try again.',
  personSaveFailed: 'Could not save this person. Your name is still here; try again.',
  personDeleteFailed: 'Could not remove this name. Try again.',
  groupSaveFailed: 'Could not save the group. Your name and people are still here; try again.',
  groupDeleteFailed: 'Could not remove this group. Try again.',
  receiptLoading: 'Loading receipt…', receiptFailed: 'Could not load the receipt. You can still view the expense.',
  receiptPreparing: 'Preparing receipt…', receiptPrepareFailed: 'Could not prepare this image. Choose it again or use another photo.',
  removedElsewhere: 'This expense was removed. The list and balances are up to date.',
};
const tr: typeof en = {
  expenseSaveFailed: 'Harcama kaydedilemedi. Girdiklerin burada duruyor; tekrar dene.',
  expenseDeleteFailed: 'Harcama silinemedi. Kayıt hâlâ duruyor; tekrar dene.',
  settlementFailed: 'Ödeme kaydedilemedi. Bakiye değişmedi; tekrar dene.',
  ratesFailed: 'Kurlar kaydedilemedi. Değişikliklerin burada duruyor; tekrar dene.',
  personSaveFailed: 'Kişi kaydedilemedi. Yazdığın ad burada duruyor; tekrar dene.',
  personDeleteFailed: 'Bu ad kaldırılamadı. Tekrar dene.',
  groupSaveFailed: 'Grup kaydedilemedi. Ad ve kişi seçimin burada duruyor; tekrar dene.',
  groupDeleteFailed: 'Grup silinemedi. Tekrar dene.',
  receiptLoading: 'Fiş yükleniyor…', receiptFailed: 'Fiş yüklenemedi. Harcama detaylarını yine de görebilirsin.',
  receiptPreparing: 'Fiş hazırlanıyor…', receiptPrepareFailed: 'Görsel hazırlanamadı. Yeniden seç veya başka bir fotoğraf kullan.',
  removedElsewhere: 'Bu harcama kaldırıldı. Liste ve bakiyeler güncel.',
};
const sv: typeof en = {
  expenseSaveFailed: 'Utgiften kunde inte sparas. Dina uppgifter finns kvar; försök igen.',
  expenseDeleteFailed: 'Utgiften kunde inte tas bort. Den finns kvar; försök igen.',
  settlementFailed: 'Betalningen kunde inte sparas. Saldot är oförändrat; försök igen.',
  ratesFailed: 'Kurserna kunde inte sparas. Dina ändringar finns kvar; försök igen.',
  personSaveFailed: 'Personen kunde inte sparas. Namnet finns kvar; försök igen.',
  personDeleteFailed: 'Namnet kunde inte tas bort. Försök igen.',
  groupSaveFailed: 'Gruppen kunde inte sparas. Namnet och personerna finns kvar; försök igen.',
  groupDeleteFailed: 'Gruppen kunde inte tas bort. Försök igen.',
  receiptLoading: 'Laddar kvitto…', receiptFailed: 'Kvittot kunde inte laddas. Du kan fortfarande se utgiften.',
  receiptPreparing: 'Förbereder kvitto…', receiptPrepareFailed: 'Bilden kunde inte förberedas. Välj den igen eller använd ett annat foto.',
  removedElsewhere: 'Utgiften har tagits bort. Listan och saldona är uppdaterade.',
};
export const moneyExperienceTranslations = { en, tr, sv };
